import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import "./Home_Page.css";
import LanguagePicker from "../Languages/LanguagePicker";
import { useLang } from "../Languages/LanguageContext";

import logo from "../assets/logo.svg";
import phoneImage from "../assets/phoneImage.png";
import phoneBackground from "../assets/phoneBackground.png";
import Play_Store_Button_Image from "../assets/Play_Store_Button_Image.svg";
import App_Store_Button_Image from "../assets/App_Store_Button_Image.svg";

import longsImage from "../assets/longsImage.png";
import miniExplore from "../assets/miniExplore.png";
import miniTaste from "../assets/miniTaste.png";
import miniCulture from "../assets/miniCulture.png";

// import likeIcon from "../assets/likeIcon.svg";
// import commentIcon from "../assets/commentIcon.svg";
// import refreshIcon from "../assets/refreshIcon.svg";
// import repostIcon from "../assets/repostIcon.svg";
// import shareIcon from "../assets/shareIcon.svg";
// import captionsIcon from "../assets/captionsIcon.svg";
import volumeIcon from "../assets/volumeIcon.svg";
import muteIcon from "../assets/muteIcon.svg";
import maximizeIcon from "../assets/maximizeIcon.svg";
import minimizeIcon from "../assets/minimizeIcon.svg";
// import moreIcon from "../assets/moreIcon.svg";

const POPULAR_URL =
  "https://api-prod.boloindia.app/api/v2/posts/website/popular";
const API_KEY =
  "20d422384a5de2afd422891a13413b5c6f6b9a6d92ebad65ad762dd42c2f88a6";

const minis = [
  { poster: miniExplore, key: "mini1" },
  { poster: miniTaste, key: "mini2" },
  { poster: miniCulture, key: "mini3" },
];

// const footerLinks = [
//   { label: "Terms of Use", path: "/Terms_of_use" },
//   { label: "Privacy Policy", path: "/Privacy_Policy" },
//   { label: "Copyright & Music Policy", path: "/Copyright_music_policy" },
//   { label: "Community Guidelines", path: "/Boloindia_Community_Guidelines" },
//   { label: "Delete Account", path: "/Delete_Account" }, // use your real route
// ];

const formatTime = (s) => {
  if (!s || isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60)
    .toString()
    .padStart(2, "0");
  return `${m}:${sec}`;
};

const safePlay = (v) => {
  if (!v) return;
  const p = v.play();
  if (p && p.catch) p.catch(() => {});
};

/* true while the element is visible in the viewport */
const useInView = (ref, threshold = 0.5) => {
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [ref, threshold]);
  return inView;
};

/* ---------- HLS (.m3u8) support (does not autoplay) ---------- */
const useHls = (videoRef, src) => {
  useEffect(() => {
    const video = videoRef.current;
    if (!video || !src) return;

    let hls;
    if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(src);
      hls.attachMedia(video);
    } else {
      video.src = src;
    }

    return () => {
      if (hls) hls.destroy();
    };
  }, [src, videoRef]);
};

/* ---------- play / pause helper ---------- */
const usePlayPause = (videoRef) => {
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    } else {
      v.pause();
    }
  };

  return { playing, setPlaying, toggle };
};

const PlayPauseButton = ({ playing, onClick, small }) => (
  <button
    type="button"
    className={`playpause${playing ? "" : " is-visible"}${
      small ? " playpause--sm" : ""
    }`}
    aria-label={playing ? "Pause" : "Play"}
    onClick={onClick}
  >
    {playing ? (
      <svg viewBox="0 0 24 24" width="50%" height="50%" fill="#ffffff">
        <rect x="6" y="5" width="4" height="14" rx="1" />
        <rect x="14" y="5" width="4" height="14" rx="1" />
      </svg>
    ) : (
      <svg viewBox="0 0 24 24" width="50%" height="50%" fill="#ffffff">
        <path d="M8 5v14l11-7z" />
      </svg>
    )}
  </button>
);

const LongsPlayer = ({ item }) => {
  const wrapRef = useRef(null);
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isFull, setIsFull] = useState(false);

  useEffect(() => {
    const onChange = () =>
      setIsFull(document.fullscreenElement === wrapRef.current);
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  const { playing, setPlaying, toggle } = usePlayPause(videoRef);

  useHls(videoRef, item && item.video);

  const inView = useInView(wrapRef, 0.5);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    if (inView) safePlay(v);
    else v.pause();
  }, [inView, item && item.video]);

  const handleSeek = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    videoRef.current.currentTime = ratio * videoRef.current.duration;
  };

  const toggleFullscreen = () => {
    const el = wrapRef.current;
    if (document.fullscreenElement) {
      document.exitFullscreen?.();
    } else {
      el.requestFullscreen?.();
    }
  };

  return (
    <div className="longs__media" ref={wrapRef}>
      <video
        ref={videoRef}
        // src={longsVideo}
        poster={(item && item.poster) || longsImage}
        loop
        muted={muted}
        playsInline
        onClick={toggle}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onLoadedMetadata={(e) => setDuration(e.target.duration)}
        onTimeUpdate={(e) =>
          setProgress((e.target.currentTime / e.target.duration) * 100)
        }
      />

      {/* center play / pause */}
      <PlayPauseButton playing={playing} onClick={toggle} />

      <div className="longs__controls">
        <span className="longs__time">{formatTime(duration)}</span>

        <div className="longs__bar" onClick={handleSeek}>
          <div className="longs__bar-fill" style={{ width: `${progress}%` }} />
        </div>

        <div className="longs__row">
          {/* like / comment / refresh / repost / share removed
          <div className="longs__group">
            <span>
              <img className="icon" src={likeIcon} alt="Like" /> 4.5k
            </span>
            <span>
              <img className="icon" src={commentIcon} alt="Comments" /> 1.2k
            </span>
            <span>
              <img className="icon" src={refreshIcon} alt="Refresh" /> 3
            </span>
            <span>
              <img className="icon" src={repostIcon} alt="Repost" /> 10
            </span>
            <span>
              <img className="icon" src={shareIcon} alt="Share" />
            </span>
          </div>
          */}

          <div className="longs__group">
            {/* <button type="button" aria-label="Captions">
              <img className="icon" src={captionsIcon} alt="" />
            </button> */}

            <button
              type="button"
              aria-label={muted ? "Unmute" : "Mute"}
              onClick={() => setMuted(!muted)}
            >
              <img
                className="icon"
                src={muted ? volumeIcon : muteIcon}
                alt=""
              />
            </button>
            <button
              type="button"
              aria-label={isFull ? "Minimize" : "Maximize"}
              onClick={toggleFullscreen}
            >
              <img
                className="icon"
                src={isFull ? minimizeIcon : maximizeIcon}
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const MiniCard = ({
  item,
  index,
  isActive,
  sectionInView,
  onEnded,
  onUserPlay,
}) => {
  const { t, lang } = useLang();
  const [muted, setMuted] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const videoRef = useRef(null);
  const { playing, setPlaying, toggle } = usePlayPause(videoRef);

  useHls(videoRef, item.video);

  // only the active mini plays, and only while the section is on screen
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    if (isActive && sectionInView) safePlay(v);
    else v.pause();
  }, [isActive, sectionInView, item.video]);

  // Esc closes the expanded view, and the page behind doesn't scroll
  useEffect(() => {
    if (!expanded) return;
    const onKey = (e) => {
      if (e.key === "Escape") setExpanded(false);
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [expanded]);

  return (
    <div className="minis__item">
      {/* keeps the grid layout while the video is expanded */}
      {expanded && <div className="minis__placeholder" />}

      <div className={`minis__video${expanded ? " is-expanded" : ""}`}>
        <video
          ref={videoRef}
          // src={item.video}
          poster={item.poster}
          muted={muted}
          playsInline
          onClick={toggle}
          onPlay={() => {
            setPlaying(true);
            onUserPlay(index);
          }}
          onPause={() => setPlaying(false)}
          onEnded={() => onEnded(index)}
        />

        {/* center play / pause */}
        <PlayPauseButton playing={playing} onClick={toggle} small />

        <div className="minis__tools">
          <button
            type="button"
            className="minis__sound"
            aria-label={muted ? "Unmute" : "Mute"}
            onClick={() => setMuted(!muted)}
          >
            <img
              className="icon icon--sm"
              src={muted ? volumeIcon : muteIcon}
              alt=""
            />
          </button>
          <button
            type="button"
            className="minis__sound"
            aria-label={expanded ? "Minimize" : "Maximize"}
            onClick={() => setExpanded(!expanded)}
          >
            <img
              className="icon icon--sm"
              src={expanded ? minimizeIcon : maximizeIcon}
              alt=""
            />
          </button>
        </div>

        {/* like / comment / refresh / repost / share / more removed
        ... (keep your existing commented block here) ...
        */}
      </div>

      {/* hardcoded label removed, text now comes from the backend
      <span className="minis__label">{t(item.key)}</span>
      */}
      {item.title && <span className="minis__label">{item.title}</span>}
    </div>
  );
};

const Home_Page = () => {
  const { t, lang } = useLang();
  const [popular, setPopular] = useState({ longs: [], minis: [] });
  const minisRef = useRef(null);
  const minisInView = useInView(minisRef, 0.1);
  const [activeMini, setActiveMini] = useState(0);

  const handleMiniEnded = (i) => {
    // 1 → 2 → 3 → back to 1
    setActiveMini((cur) => (cur === i ? (i + 1) % miniItems.length : cur));
  };

  // fetch longs + minis from the backend
  useEffect(() => {
    const controller = new AbortController();

    fetch(POPULAR_URL, {
      method: "GET",
      headers: {
        "x-api-key": API_KEY,
        "Content-Type": "application/json",
      },
      signal: controller.signal,
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Popular posts failed: ${res.status}`);
        return res.json();
      })
      .then((json) => {
        if (!json.success || !json.data) return;
        const normalize = (p) => ({
          poster: p.thumbnail_url,
          video: p.media_url,
          title: p.title,
        });
        setPopular({
          longs: (json.data.longs || []).map(normalize),
          minis: (json.data.minis || []).map(normalize),
        });
      })
      .catch((err) => {
        if (err.name !== "AbortError") console.error(err);
      });

    return () => controller.abort();
  }, []);

  const longItem = popular.longs[0]; // only 1 long video
  const miniItems = popular.minis.length ? popular.minis : minis;

  const handlePlayStoreClick = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.bolo.india",
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handleAppStoreClick = () => {
    window.open(
      "https://apps.apple.com/in/app/bolo-india-media/id6781571060",
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <div className="home">
      {/* ---------- HERO ---------- */}
      <section className="hero">
        <img className="hero__bg" src={phoneBackground} alt="" />

        <div className="hero__left">
          <div className="hero__logo">
            <img src={logo} alt="Bolo India" />
            <span>Bolo India</span>
          </div>

          <h1 className="hero__title">
            {lang === "en" ? (
              <>
                India's{" "}
                <span className="hero__first">
                  1<sup>st</sup>
                </span>
              </>
            ) : (
              t("heroLine1")
            )}
            <br />
            {t("heroLine2")}
            <br />
            {t("heroLine3")}
          </h1>

          <h3 className="hero__subtitle">{t("heroSubtitle")}</h3>
          <p className="hero__desc">{t("heroDesc")}</p>

          <div className="hero__stores">
            <button type="button" onClick={handlePlayStoreClick}>
              <img src={Play_Store_Button_Image} alt="Get it on Google Play" />
            </button>
            <button type="button" onClick={handleAppStoreClick}>
              <img
                src={App_Store_Button_Image}
                alt="Download on the App Store"
              />
            </button>
          </div>
        </div>

        <div className="hero__right">
          <div className="hero__phoneWrap">
            <img className="hero__phone" src={phoneImage} alt="Phone" />
            <div className="hero__screen">
              <LanguagePicker />
            </div>
          </div>
        </div>
      </section>
      {/* ---------- ABOUT CARD ---------- */}
      <section className="about">
        <div className="about__card">
          <h2 className="about__brand">Bolo India</h2>
          <h3 className="about__heading">{t("aboutHeading")}</h3>
          <p className="about__text">{t("aboutText")}</p>
        </div>
      </section>
      {/* ---------- LONGS ---------- */}
      <section className="longs">
        <h2 className="longs__title">{t("longsTitle")}</h2>
        <h3 className="longs__subtitle">{t("longsSubtitle")}</h3>
        <p className="longs__desc">{t("longsDesc")}</p>

        {/* <LongsPlayer /> */}
        <LongsPlayer item={longItem} />
      </section>
      {/* ---------- MINIS ---------- */}
      <section className="minis" ref={minisRef}>
        <h2 className="minis__title">{t("minisTitle")}</h2>
        <h3 className="minis__subtitle">{t("minisSubtitle")}</h3>
        <p className="minis__desc">{t("minisDesc")}</p>

        <div className="minis__grid">
          {miniItems.map((item, i) => (
            <MiniCard
              item={item}
              key={item.video || item.key || i}
              index={i}
              isActive={activeMini === i}
              sectionInView={minisInView}
              onEnded={handleMiniEnded}
              onUserPlay={setActiveMini}
            />
          ))}
        </div>
      </section>

      {/* ---------- FOOTER ---------- */}
      <footer className="footer">
        <span
          className="footer__link"
          onClick={() => window.open("/Terms_of_use", "_blank")}
        >
          Terms of Use
        </span>
        <span className="footer__sep">|</span>

        <span
          className="footer__link"
          onClick={() => window.open("/Privacy_Policy", "_blank")}
        >
          Privacy Policy
        </span>
        <span className="footer__sep">|</span>

        <span
          className="footer__link"
          onClick={() => window.open("/Copyright_music_policy", "_blank")}
        >
          Copyright & Music Policy
        </span>
        <span className="footer__sep">|</span>

        <span
          className="footer__link"
          onClick={() =>
            window.open("/Boloindia_Community_Guidelines", "_blank")
          }
        >
          Community Guidelines
        </span>
        <span className="footer__sep">|</span>

        <span className="footer__link" onClick={() => window.open("/Login")}>
          Delete Account
        </span>
      </footer>
    </div>
  );
};

export default Home_Page;
